import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useStyles } from './styles';
import { PreviewData } from './types';
import { useStore } from 'hooks/useRootStore';
import { toFormatSum } from 'utils';

const CardPreview: FC<PreviewData> = ({
  coreCheckHandle,
  addonCheckHandle,
  users,
  currentCoreUsers,
  currentAddonUsers,
  totalUsers,
}) => {
  const classes = useStyles();
  const {
    upgradeLicenseStore: { featureData },
  } = useStore();

  // Use passed props with fallback to store data
  const displayCurrentCoreUsers = currentCoreUsers ?? featureData?.currentNumberOfUserCore ?? users;
  const displayCurrentAddonUsers = currentAddonUsers ?? featureData?.currentNumberOfUserAddOn ?? users;
  const displayTotalUsers = totalUsers ?? featureData?.numberOfUsers ?? users;
  const displayPreviousCoreUsers = featureData?.previousNumberOfUsersCore ?? 0;
  const displayPreviousAddonUsers = featureData?.previousNumberOfUsersAddOn ?? 0;

  return (
    <>
      <Grid container className={classes.displayBox}>
        <Grid
          item
          xs={
            coreCheckHandle === true && addonCheckHandle === false
              ? 12
              : coreCheckHandle === false && addonCheckHandle === true
              ? 12
              : 6
          }
        >
          {coreCheckHandle === true ? (
            <Grid>
              <p className={classes.displayTitle}>Core Features</p>
              <Grid className={classes.textColor}>
                <div>
                  <span className={classes.textBox}>Current License: </span>
                  <span>
                    {' '}
                    {toFormatSum(displayCurrentCoreUsers)} {'Users'}
                  </span>{' '}
                </div>
                <div>
                  <span className={classes.textBox}> Previous License: </span>{' '}
                  <span>
                    {' '}
                    {toFormatSum(displayPreviousCoreUsers)} {'Users'}
                  </span>
                </div>
                <div>
                  <span className={classes.textBox}>Total:</span>
                  <span>
                    {' '}
                    {toFormatSum(displayTotalUsers)} {'Users'}
                  </span>
                </div>
              </Grid>
            </Grid>
          ) : (
            <Grid>
              <p className={classes.displayTitle}>Add-On Users</p>
              <Grid className={`${classes.textColor}`}>
                <div>
                  <span className={classes.textBox}>Current </span>
                  <span>
                    {' '}
                    {toFormatSum(displayCurrentAddonUsers)}
                    {'Users'}
                  </span>{' '}
                </div>
                <div>
                  <span className={classes.textBox}> Previous </span> {toFormatSum(displayPreviousAddonUsers)}
                  {'Users'}
                </div>
                <div>
                  <span className={classes.textBox}>Total </span>
                  <span>
                    {' '}
                    {toFormatSum(displayTotalUsers)}
                    {'Users'}
                  </span>
                </div>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={6}>
          {coreCheckHandle === true && addonCheckHandle === true && (
            <Grid>
              <p className={classes.displayTitle}>Add-On Services</p>
              <Grid className={`${classes.textColor} ${classes.leftData}`}>
                <div>
                  <span className={classes.textBox}>Current License: </span>
                  <span>
                    {' '}
                    {toFormatSum(displayCurrentAddonUsers)} {'Users'}
                  </span>{' '}
                </div>
                <div>
                  <span className={classes.textBox}> Previous License: </span> {toFormatSum(displayPreviousAddonUsers)}{' '}
                  {'Users'}
                </div>
                <div>
                  <span className={classes.textBox}>Total: </span>
                  <span>
                    {' '}
                    {toFormatSum(displayTotalUsers)} {'Users'}
                  </span>
                </div>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default CardPreview;
